import AssetCreationForm from './Form.jsx';

export default AssetCreationForm;
